import type { ReactNode } from 'react';
import Link from 'next/link';
import { Box, useTheme } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

/**
 * Shared mobile "card row" shell used by the public-search animal and
 * sale-catalogue grid cell renderers.
 *
 * Renders a full-width navigating `<Link>` (which stops the data-grid
 * row-click event from firing a second navigation) wrapping the flex row
 * layout. Callers supply the leading badge, the main content, and rely on the
 * trailing chevron rendered here.
 */
export function MobileCardLinkRow({
  href,
  children,
}: {
  href: string;
  children: ReactNode;
}) {
  const theme = useTheme();
  return (
    <Link
      href={href}
      prefetch={false}
      onClick={(event) => event.stopPropagation()}
      style={{
        display: 'block',
        width: '100%',
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          width: '100%',
          minWidth: 0,
          minHeight: 60,
          px: '14px',
          py: 1,
          borderTop: `1px solid ${theme.palette.divider}`,
          boxSizing: 'border-box',
        }}
      >
        {children}
        <ChevronRightIcon
          sx={{ fontSize: 16, color: 'text.disabled', flexShrink: 0 }}
        />
      </Box>
    </Link>
  );
}
